/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropVideoBody
 */
export interface DropVideoBody {
    /**
     * Link to the video on YouTube, Twitch or Kick. Pasted, not looked up.
     * @type {string}
     * @memberof DropVideoBody
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropVideoBody
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof DropVideoBody
     */
    durationSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof DropVideoBody
     */
    thumbnailUrl?: string;
}

/**
 * Check if a given object implements the DropVideoBody interface.
 */
export function instanceOfDropVideoBody(value: object): value is DropVideoBody {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function DropVideoBodyFromJSON(json: any): DropVideoBody {
    return DropVideoBodyFromJSONTyped(json, false);
}

export function DropVideoBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropVideoBody {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'title': json['title'] == null ? undefined : json['title'],
        'durationSeconds': json['durationSeconds'] == null ? undefined : json['durationSeconds'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
    };
}

export function DropVideoBodyToJSON(json: any): DropVideoBody {
    return DropVideoBodyToJSONTyped(json, false);
}

export function DropVideoBodyToJSONTyped(value?: DropVideoBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'title': value['title'],
        'durationSeconds': value['durationSeconds'],
        'thumbnailUrl': value['thumbnailUrl'],
    };
}

